import { gql } from '@apollo/client';

/**
 * Who the person is. The long lists left this request for the tabs' own paged
 * queries, because `fetchUserDetails` cannot page a relation: the page opens on
 * two root fields however much someone has done, and a tab costs one when opened.
 */
export const USER_DETAILS_PAGE = gql`
  query fetchUserDetails($id: Int!) {
    fetchUserDetails(id: $id) {
      id
      uid
      username
      firstName
      lastName
      email
      phone
      userLevel
      level
      gender
      totalPoints
      membershipType
      streetAddress
      tShirtSize
      role
      ambassador
      isVerified
      isEmailVerified
      isPhoneVerified
      phoneVerifiedAt
      isDeleted
      isBanned
      bannedAt
      banReason
      bannedBy
      isNotificationEnabled
      pushPermission
      pushPermissionAt
      currentLoginStreak
      longestLoginStreak
      latestIpAddress
      createdAt
      updatedAt
      regionCity
      regionState
      regionStateCode
      regionCountry
      regionCountryCode
      ProfileImage {
        url
      }
      CommunityUser {
        streamChannelId
      }
      InitiativeProgress {
        id
        steps
        completedAt
        Initiative {
          steps
          InitiativeTranslation {
            locale
            title
          }
        }
      }
      UserAchievements {
        id
        isCompleted
        updatedAt
        Achievement {
          title
          points
        }
      }
    }
  }
`;

export const USER_SUMMARY = gql`
  query AdminUserSummary($userId: Int!) {
    adminUserSummary(userId: $userId) {
      lastSeenAt
      appOpens
      activeDaysLast30
      recommendations
      recommendationsWithdrawn
      reviews
      reviewsVisible
      referrals
      achievementsCompleted
      chatGroups
      chatMessagesLogged
      feedbackSent
      notifications
      notificationsUnread
      textsSent
      whatsAppSent
      whatsAppReceived
      crmContactId
      topScreens {
        screen
        views
      }
      devices {
        timeZone
        locale
        registeredAt
        lastUpdatedAt
      }
      referredBy {
        id
        name
        username
        referredAt
      }
      onboarding {
        goal
        heardAbout
        heardAboutDetail
      }
    }
  }
`;

export const USER_RECOMMENDATIONS = gql`
  query AdminUserRecommendations($userId: Int!, $pagination: PaginationInputType, $withdrawn: Boolean) {
    adminUserRecommendations(userId: $userId, pagination: $pagination, withdrawn: $withdrawn) {
      total
      businessRecommendations {
        id
        isBlackFriendly
        createdAt
        withDrawnAt
        Business {
          id
          placeId
          name
          Category {
            category
          }
          BusinessAddresses {
            formattedAddress
          }
        }
      }
    }
  }
`;

export const USER_REVIEWS = gql`
  query AdminUserReviews($userId: Int!, $pagination: PaginationInputType) {
    adminUserReviews(userId: $userId, pagination: $pagination) {
      total
      reviews {
        id
        content
        visible
        moderatedAt
        createdAt
        Business {
          id
          placeId
          name
        }
      }
    }
  }
`;

export const USER_WHATSAPP = gql`
  query AdminUserWhatsAppMessages($userId: Int!, $pagination: PaginationInputType, $direction: WhatsAppDirection) {
    adminUserWhatsAppMessages(userId: $userId, pagination: $pagination, direction: $direction) {
      total
      messages {
        id
        direction
        phone
        message
        createdAt
        note
        media {
          url
          contentType
        }
      }
    }
  }
`;

export const USER_REFERRALS = gql`
  query AdminUserReferrals($userId: Int!, $pagination: PaginationInputType) {
    adminUserReferrals(userId: $userId, pagination: $pagination) {
      total
      referrals {
        id
        createdAt
        userId
        username
        name
        email
        phone
        isDeleted
        isVerified
      }
    }
  }
`;

export const USER_ACTIVITY = gql`
  query AdminUserActivity($userId: Int!, $kinds: [AdminUserActivityKind!], $take: Int, $after: String) {
    adminUserActivity(userId: $userId, kinds: $kinds, take: $take, after: $after) {
      hasNextPage
      endCursor
      items {
        id
        kind
        type
        occurredAt
        title
        body
        note
        businessName
        businessPlaceId
        otherUserId
        otherUserName
        screen
      }
    }
  }
`;
